import React from 'react';
import axios from 'axios';
import SearchForm from '../../component/SearchForm';
import { Link, withRouter } from 'react-router-dom';
import Pagination from '../../component/Pagination';
import InvoiceStatus from '../../component/InvoiceStatus';
import AlertLabel from '../../component/AlertLabel';
import { Field, reduxForm } from 'redux-form';
import { RenderDatePicker, RenderSearchForm } from '../../component/formInput';
import { connect } from 'react-redux';
import moment from 'moment';
import { StringUtils } from '../../utils/javascriptUtils';
var numeral = require('numeral');
var _ = require('lodash');

function BillingStatusCase(status) {
  switch(status) {
    case "pending": {
      return "Đang xử lý"
    }
    case "cancel" : {
      return "Hủy"
    }
    case "finish" : {
      return "Hoàn Tất"
    }
    default: {
      return "Tất cả"
    }
  }
}

function BillingTypeCase(type) {
  switch(type) {
    case "vnpay_deposit_temp": {
      return "Phương thức VNPAY"
    }
    case "momo_deposit_temp" : {
      return "Ví MOMO"
    }
    default: {
      return "Tất cả"
    }
  }
}

function BillingTypeSelect(BillingTypeSelected, onBillingTypeChange) {
  return (
    <div style={{float: 'right', margin: 5}} className="btn-group">
      <button type="button" className="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
        {BillingTypeCase(BillingTypeSelected)}
      </button>
      <div className="dropdown-menu" x-placement="bottom-start">
        <a onClick={() => onBillingTypeChange("all")} className="dropdown-item">Tất cả</a>
        <a onClick={() => onBillingTypeChange("vnpay_deposit_temp")} className="dropdown-item">Phương thức VNPAY</a>
        <a onClick={() => onBillingTypeChange("momo_deposit_temp")} className="dropdown-item">Ví MoMo</a>
      </div>
    </div>
  )
}

function BillingStatusSelect(BillingStatusSelected, onBillingStatusChange) {
  return (
    <div style={{float: 'right', margin: 5}} className="btn-group">
      <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
        {BillingStatusCase(BillingStatusSelected)}
      </button>
      <div className="dropdown-menu" x-placement="bottom-start">
        <a onClick={() => onBillingStatusChange("all")} className="dropdown-item">Tất cả</a>
        <a onClick={() => onBillingStatusChange("finish")} className="dropdown-item">Hoàn tất</a>
        <a onClick={() => onBillingStatusChange("pending")} className="dropdown-item">Đang xử lý</a>
        <a onClick={() => onBillingStatusChange("cancel")} className="dropdown-item">Hủy</a>
      </div>
    </div>
  )
}

function BillingDatePicker(from_date, to_date, onDateChange, clearDataFilter) {
 
  return ( 
    <div style={{float: "right"}}>
      <div style={{display: 'inline-flex', marginRight:10 }}>
        <span className="input-group-text" style={{height:'fit-content'}}>
          <i style={{ height:20 }} className="icon-calendar22"></i>
        </span>
        <Field
          name="from_date"
          placeholder="dd/mm/yyyy"
          dateFormat="dd/MM/yyyy"
          onChangeAction={(value)=>onDateChange(value, to_date)}
          component={RenderDatePicker}
          />
      </div>
      <div style={{display: 'inline-flex', marginRight:10 }}>
        <span className="input-group-text" style={{height:'fit-content'}}>
          <i style={{ height: 20 }} className="icon-calendar22"></i>
        </span>
        <Field
          name="to_date"
          placeholder="dd/mm/yyyy"
          dateFormat="dd/MM/yyyy"
          onChangeAction={(value)=>onDateChange(from_date, value)}
          component={RenderDatePicker}/>
      </div>
      <div style={{display: 'inline-flex',height:'fit-content'}}>
        <button onClick={()=> clearDataFilter()} style={{whiteSpace:'nowrap', width:'inherit'}} className="btn btn-warning">x</button>
      </div>
    </div>
  )
}

function BillingInvoiceRows(data) {
  const billing_rows = _.map(data, function(i, index) {
    return (
      <tr key={index} className={i.amount < 0 && "alpha-orange"} style={{borderBottom: "1px solid #ddd"}}>
        <td>
          {i.code}
        </td>
        <td>
          {i.user && i.user.full_name}
          <br/>
          <small className="text-muted">{i.user && i.user.email}</small>
        </td>
        <td>
          {numeral(i.total).format("0,0")}
        </td>
        <td>
          {i.type}
        </td>
        <td>
          {i.status}
        </td>
        <td>
          {i.billing && i.billing.code}
        </td>
        <td>{moment(i.created_date).format("DD/MM/YYYY hh:mm:ss")}</td>
      </tr>
      )
  })
  return billing_rows;
}

class BillingInvoiceTable extends React.Component {
  constructor(props) {
    const {type} = props.routeProps.match.params;
    const {status} = props.routeProps.match.params;
    super(props);
    this.state = {
      table_data: [],
      table_query: {
        current_page: 1,
        number_of_row: 20,
        sort_by: "",
        sort_asc: false,
        from_date: null,
        to_date: null,
        search_value: "",
        type: type,
        status: status,
      },
    }
  }

  componentDidMount() {
    this.reload(this.state.table_query);
  }

  gotoPage = (page) => {
    const table_query = {
      ...this.state.table_query,
      current_page: page
    };
    this.reload(table_query);
  }
  
  reload = (table_query) => {
    const self = this;

    axios({
      method: 'post',
      url: window.api_url + '/admin/api/billing-invoice/list',
      withCredentials: true,
      data: table_query
    }).then(function (response) {
      self.setState({
        ...self.state,
        table_query: table_query,
        table_data: response.data.data
      })
    });
  }

  onDateChange = (from_date, to_date) => {
    const table_query = {
      ...this.state.table_query,
      search_value: "",
      current_page: 1,
      from_date: moment(from_date).format("YYYY-MM-DD hh:mm:ss"),
      to_date: moment(to_date).format("YYYY-MM-DD 23:59:59")
    };
    this.setState({
      ...this.state,
      table_query: table_query
    });

    if(from_date && to_date) {
      this.reload(table_query);
    }
  }

  onSearchSubmit = (values) => {
    const search_value = values.search ? values.search : "";
    const { history } = this.props;
    const table_query = {
      ...this.state.table_query,
      search_value: search_value,
      current_page: 1,
      type: "all"

    };
    history.push("?search=" + search_value);
    this.reload(table_query);
  }

  clearDataFilter = () => {
    const { reset } = this.props;
    const table_query = {
      ...this.state.table_query,
      search_value: "",
      current_page: 1,
      from_date: null,
      to_date: null,
      type: "all",
      status: "all"
    };
    this.setState({
      ...this.state,
      table_query: table_query
    });
    reset();
    this.reload(table_query);
  }

  onKeyPess = (key_code) => {
    const { history, role_path } = this.props;
    if (key_code == "Escape") {
      history.push(role_path + "/billing-invoice/type/all/status/all")
      this.clearDataFilter();
    }
  }

  onBillingTypeChange = (type) => {
    const { history, role_path } = this.props;
    const { table_query } = this.state;

    const data = {
      ...table_query,
      type: type
    };
    this.reload(data);
    history.push(role_path + `/billing-invoice/type/${type}/status/${table_query.status}`)
  }

  onBillingStatusChange = (status) => {
    const { history, role_path } = this.props;
    const { table_query } = this.state;

    const data = {
      ...table_query,
      status: status
    };
    this.reload(data);
    history.push(role_path + `/billing-invoice/type/${table_query.type}/status/${status}`)
  }

  render() {
    const { handleSubmit } = this.props;
    const { table_query, table_data } = this.state;
    return(
      <React.Fragment>
        <div className="page-header">
          <div className="page-header-content header-elements-md-inline">
            <div className="page-title d-flex">
              <h4>
                <i className="icon-paragraph-justify2 mr-2"></i>
                <span className="text-semibold">Hóa Đơn Nạp Tiền</span>
              </h4>
            </div>
          </div>
        </div>
        <br/>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-body">
            <form style={{display:"inline-flex"}} onSubmit={handleSubmit(this.onSearchSubmit)}>
                <div style={{ width:"100%", paddingRight:5}}>
                  <Field
                    name="search"
                    placeholder="Mã Hóa Đơn, Mã Thanh Toán hoặc Email khách hàng"
                    defaultValue = {table_query.search_value}
                    onKeyAction={(ev)=> this.onKeyPess(ev)}
                    component={RenderSearchForm}
                  />
                </div>
              </form>
              {StringUtils.isEmptyOrSpaces(table_query.search_value) && <div className="row">
                <div className="col-md-6">
                </div>
                <div className="col-md-6">
                  {BillingDatePicker(table_query.from_date, table_query.to_date, this.onDateChange, this.clearDataFilter)}
                </div>
                <div className="col-md-6">
                </div>
                <div className="col-md-6">
                  {BillingStatusSelect(table_query.status, this.onBillingStatusChange)} 
                  {BillingTypeSelect(table_query.type, this.onBillingTypeChange)} 
                </div>
                </div>}
              <div className="table-responsive">
                <table className="table table-togglable table-hover default footable-loaded footable">
                  <thead>
                  <tr>
                    <th data-toggle="true" className="footable-visible footable-first-column">
                      Code
                    </th>
                    <th>Khách hàng</th>
                    <th data-hide="phone,tablet" className="">
                      Số tiền
                    </th>
                    <th data-hide="phone,tablet" className="">
                      Phương thức
                    </th>
                    <th data-hide="phone,tablet" className="">
                      Trạng thái
                    </th>
                    <th data-hide="phone,tablet" className="">
                      Mã thanh toán (Bill)
                    </th>
                    <th data-hide="phone" className="">Ngày</th>
                  </tr>
                  </thead>
                  <tbody>
                    {table_data.data && BillingInvoiceRows(table_data.data)}
                  </tbody>
                </table>
              </div>
            </div>
            <Pagination query={table_query} data={table_data} handle={this.gotoPage}/>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapState = state => ({
  userProfile: state.userProfile.data,
  role_path: state.userProfile.role_path,
});

const mapDispatch = (dispatch) => ({

});

const BillingInvoiceTableWrapper = reduxForm({
  form: 'BillingInvoiceTable',
  destroyOnUnmount: true,
  enableReinitialize: true,
})(BillingInvoiceTable);

export default connect(mapState, mapDispatch)(withRouter(BillingInvoiceTableWrapper));